import styled from 'styled-components'

import { FONT_WEIGHT, FONT_SIZE, SourceCodePro } from '@global/fonts'

export const StyledText = styled.p`
  ${SourceCodePro};
  margin: 0;
  width: ${({ width }) => width || 'auto'};

  color: ${({ disabled, color, theme }) => {
    if (disabled) return theme.colors.text.disabled
    return theme.colors[color]?.main ?? theme.colors.text.content
  }};

  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};

  text-align: ${({ align }) => {
    switch (align) {
      case 'center': return 'center'
      case 'right': return 'right'
      default: return 'left'
    }
  }};

  ${({ weight }) => {
    switch (weight) {
      case 'xlight': return FONT_WEIGHT.XLIGHT
      case 'light': return FONT_WEIGHT.LIGHT
      case 'semibold': return FONT_WEIGHT.SEMIBOLD
      case 'bold': return FONT_WEIGHT.BOLD
      case 'xbold': return FONT_WEIGHT.XBOLD
      default: return FONT_WEIGHT.REGULAR
    }
  }};

  ${({ size }) => {
    switch (size) {
      case 'xsmall': return FONT_SIZE.XSMALL
      case 'small': return FONT_SIZE.SMALL
      case 'large': return FONT_SIZE.LARGE
      case 'xlarge': return FONT_SIZE.XLARGE
      case 'xxlarge': return FONT_SIZE.XXLARGE
      default: return FONT_SIZE.MEDIUM
    }
  }}
`
